export default __webpack_public_path__ + "static/banner7-1cbd35d9a46bacb61a733048fa202864.png";